export default function Controls() {
  return (
    <div className="controls">
      <h2>Stream of Consciousness</h2>
      <p>Press ↑ / W to drift forward · ↓ / S to row back</p>
      <p>Error: this is a dummy curation, the agent failed. Please try again</p>
    </div>
  );
}
